import React, { useState, useEffect } from "react";
import {formatEuro} from "../../utils/formatPrice";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import { getCountries } from "libphonenumber-js/max";

const FormUser = ({ reservationData, setReservationData, handleChange, handlePhoneChange, handleCountryChange, fieldRefs}) => {
    const [countryOptions, setCountryOptions] = useState([]);

   

    useEffect(() => {
        const countries = getCountries();
        const options = countries.map(country => ({
            value: country,
            label: new Intl.DisplayNames(['en'], { type: 'region' }).of(country),
        }));
        setCountryOptions(options);
    }, []);

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#333', // Fond sombre
            color: '#ffc107', // Couleur du texte
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#444' : '#333', // Fond sombre pour les options
            color: '#ffc107', // Couleur du texte
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#000', // Couleur du texte de la valeur sélectionnée
        }),
    };

    return (
        <section id="reservation" className="container-fluid py-5 bg-warning">
            <div className="container p-2 p-md-5">
                <div className="row align-items-center">
                    {/* Texte explicatif à gauche */}
                    <div className="col-12 mb-4">
                        <h2 className="mb-4 text-dark">Book Your Transfer</h2>
                        <p> Complete the details below to finalize your reservation.</p>
                        <ul>
                            <li>From : <strong>{reservationData.depart}</strong> </li>
                            <li>To : <strong>{reservationData.arrive}</strong> </li>
                            <li>Type : <strong>{reservationData.shuttle_private}</strong> </li>
                            <li>Passengers :  <strong>{reservationData.pax_adult_t1} adults, {reservationData.pax_child_t1} children, {reservationData.pax_baby_t1} babies</strong></li>
                        </ul>
                    </div>

                    {/* Formulaire dynamique à droite */}
                    <div className="col-lg-12">
                        {/* Champs pour les informations personnelles */}
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor="lastName">Last name : </label>
                                <input
                                    ref={fieldRefs.lastname}
                                    type="text"
                                    className="form-control"
                                    id="lastname"
                                    value={reservationData.lastname || ""}
                                    onChange={handleChange}
                                    placeholder="Your lastname"
                                    required
                                />
                            </div>
                            <div className="col">
                                <label htmlFor="firstname">First name : </label>
                                <input
                                    ref={fieldRefs.firstname}
                                    type="text"
                                    className="form-control"
                                    id="firstname"
                                    value={reservationData.firstname || ""}
                                    onChange={handleChange}
                                    placeholder="Your firstname"
                                    required
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor="phoneMobile">Mobile phone : </label>
                                <PhoneInput
                                    ref={fieldRefs.phoneMobile}
                                    id={`phoneMobile`}
                                    country={reservationData.phoneCountryCode || "us"}
                                    value={reservationData.phoneMobile}
                                    onChange={handlePhoneChange}
                                    placeholder="Your internaional mobile phone"
                                    inputClass="custom-phone-input"
                                    buttonClass="custom-phone-input"
                                    inputProps={{
                                        id: "phoneMobile",
                                        name: "phoneMobile",
                                        required: true,
                                    }}
                                />
                                <input
                                    type="hidden"
                                    id="phoneHome"
                                    name="phoneHome"
                                    value={reservationData.phoneHome}
                                />
                            </div>
                            <input
                                    type="hidden"
                                    id="phoneHome"
                                    name="phoneHome"
                                    value={reservationData.phoneHome}
                                />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email">Email : </label>
                            <input
                                ref={fieldRefs.email}
                                type="email"
                                className="form-control"
                                id="email"
                                value={reservationData.email}
                                placeholder="Your Email"
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Champs pour les informations d'adresse */}
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor="address">Address : </label>
                                <input
                                    ref={fieldRefs.address}
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    value={reservationData.address}
                                    placeholder="Your address complete"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor="postcode">Postcode : </label>
                                <input
                                    ref={fieldRefs.postcode}
                                    type="text"
                                    className="form-control"
                                    id="postcode"
                                    value={reservationData.postcode}
                                    placeholder="Your zip code"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col">
                                <label htmlFor="city">City : </label>
                                <input
                                    ref={fieldRefs.city}
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    value={reservationData.city}
                                    placeholder="Your city"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        {/* Champs pour le pays */}
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor="country">Country : </label>
                                <Select
                                    ref={fieldRefs.country}
                                    options={countryOptions}
                                    value={countryOptions.find(option => option.value === reservationData.country)}
                                    onChange={handleCountryChange}
                                    placeholder="Select your country"
                                    styles={customStyles}
                                    required
                                />
                            </div>
                        </div>

                        <h2 className="mb-4 text-dark pt-5">
                            <div>Passengers {reservationData.pax_t1}</div>
                            <div className="text-end">
                                {reservationData?.prix_cb ? (
                                    <>
                                        {reservationData.prix_cb > 0 && <span>&nbsp;{formatEuro(reservationData.prix_cb)}(CB)</span>}
                                        {reservationData.prix_cash > 0 && <span>&nbsp;{formatEuro(reservationData.prix_cash)}(Cash)</span>}
                                    </>
                                ) : null}
                            </div>
                        </h2>

                        {/* Champs pour les passagers */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label htmlFor="pax_adult_t1">Adults (+11 years old) : </label>
                            </div>
                            <div className="col-md-6">
                                <input
                                    ref={fieldRefs.pax_adult_t1}
                                    type="number"
                                    className="form-control"
                                    id="pax_adult_t1"
                                    value={reservationData.pax_adult_t1}
                                    onChange={handleChange}
                                    min="1"
                                    max="50"
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label htmlFor="pax_child_t1">Children (3 to 11 years old) : </label>
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="pax_child_t1"
                                    value={reservationData.pax_child_t1}
                                    onChange={handleChange}
                                    min="0"
                                    max="50"
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label htmlFor="pax_baby_t1">Babies (-3 years old) : </label>
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="pax_baby_t1"
                                    value={reservationData.pax_baby_t1}
                                    onChange={handleChange}
                                    min="0"
                                    max="50"
                                />
                            </div>
                        </div>

                        <h2 className="mb-4 text-dark pt-5">Luggage</h2>
                        <div className="row mb-3">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="check_in_luggage">Check in luggage : </label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="check_in_luggage"
                                        value={reservationData.check_in_luggage}
                                        onChange={handleChange}
                                        min="0"
                                        max="10"
                                        placeholder="Check in luggage"
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="cabin_bag">Cabin bag : </label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="cabin_bag"
                                        value={reservationData.cabin_bag}
                                        onChange={handleChange}
                                        min="0"
                                        max="10"
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="stroller_single">Single stroller : </label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="stroller_single"
                                        value={reservationData.stroller_single}
                                        onChange={handleChange}
                                        min="0"
                                        max="10"
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="stroller_double">Double stroller : </label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="stroller_double"
                                        value={reservationData.stroller_double}
                                        onChange={handleChange}
                                        min="0"
                                        max="10"
                                    />
                                </div>
                            </div>
                            
                            

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FormUser;
